import styled from "rn-css";
import { light_black } from "../../StyleHelpers";

export const StyledOuterContainer = styled.View`
	flex: 1;
	height: 100%;
	background-color: ${light_black};
	z-index: -1;
`;
